import { GlButton, GlButtonGroup, GlTooltipDirective } from '@gitlab/ui';
import glFeatureFlagMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import { hasBoardViewMode, viewModeOptions } from 'ee_else_ce/work_items/view_modes';
import { VIEW_MODE_BOARD, VIEW_MODE_TABLE } from '../constants';
export default {
    name: 'WorkItemViewModeToggle',
    components: {
        GlButton,
        GlButtonGroup
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        glFeatureFlagMixin()
    ],
    props: {
        viewMode: {
            type: String,
            required: true
        }
    },
    emits: [
        'toggle-view-mode'
    ],
    computed: {
        availableViewModeOptions () {
            return viewModeOptions.filter((option)=>{
                if (option.value === VIEW_MODE_TABLE) {
                    return Boolean(this.glFeatures.planningViewTable);
                }
                if (option.value === VIEW_MODE_BOARD) {
                    return hasBoardViewMode && Boolean(this.glFeatures.planningViewBoards);
                }
                return true;
            });
        }
    },
    methods: {
        onToggleViewMode (newViewMode) {
            this.$emit('toggle-view-mode', newViewMode);
        },
        isPressed (value) {
            return value === this.viewMode ? 'true' : 'false';
        }
    }
};
